import Vue from 'vue'

Vue.filter('dateShorthand', function (value) {
  return moment(value).format('MMM Do, YYYY');
});

Vue.filter('dateTimeShorthand', function (value) {
  return moment(value).format('MMM Do, YYYY - h:mm A');
});

Vue.filter('showProp', function (value, key) {
  return value[key] ? value[key] : '---';
});

Vue.filter('camelToReadable', function (value) {
  return value.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); })
});

Vue.filter('money', function (value) {
  return '$' + Number(value).toFixed(2);
});


// WEBPACK FOOTER //
// ./src/global/filters.js